import { render, staticRenderFns } from "./reviewsComponent.vue?vue&type=template&id=657082de"
import script from "./reviewsComponent.vue?vue&type=script&lang=js"
export * from "./reviewsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports